// 任务栏拖动移除固定应用的回收容器id
export const TRASH_ID = 'trash-container';
// 任务栏app容器id
export const DOCK_APP_CONTAINER_ID = 'dockAppContext';
// 任务栏app id前缀
export const DOCK_APP_PREV_ID = 'dockApp-';

export const WEATHER_APP_CODE = 'weatherService';
